import type { Player } from '@infiltre/shared';
import { selectAlivePlayers, selectRoom } from '@/entities/room';
import type { AppState } from '@/shared/lib/zustand-types';
import { HandoffStageKind } from './slice';

export const selectCurrentRevealPlayer = (s: AppState): Player | null => {
  if (s.handoff.kind !== HandoffStageKind.WordReveal) return null;
  const room = selectRoom(s);
  if (!room) return null;
  return room.players[s.handoff.index] ?? null;
};

export const selectCurrentVoter = (s: AppState): Player | null => {
  if (s.handoff.kind !== HandoffStageKind.Vote) return null;
  const alive = selectAlivePlayers(s);
  return alive[s.handoff.index] ?? null;
};

export const selectIsAllRevealed = (s: AppState): boolean => {
  if (s.handoff.kind !== HandoffStageKind.WordReveal) return false;
  const room = selectRoom(s);
  if (!room) return false;
  return s.handoff.index >= room.players.length;
};

export const selectIsAllVoted = (s: AppState): boolean => {
  if (s.handoff.kind !== HandoffStageKind.Vote) return false;
  return s.handoff.index >= selectAlivePlayers(s).length;
};
